import type { UpdateStates } from 'bundles/account-settings/constants/SettingsConstants';

export const NotificationPreferenceChannels = {
  EMAIL: 'email',
  PUSH: 'push',
} as const;

export type NotificationPreferenceChannel =
  (typeof NotificationPreferenceChannels)[keyof typeof NotificationPreferenceChannels];

type GlobalNotificationPreferenceCategory = 'promotions' | 'recommendations' | 'volunteer' | 'degrees' | 'reminders';

export type GlobalChannelNotificationPreferences = Record<
  GlobalNotificationPreferenceCategory,
  Record<NotificationPreferenceChannel, boolean>
>;

export type CourseEmailPreference = {
  id: string;
  value: {
    announcements: boolean;
    reminders: boolean;
    discussionForums: boolean;
  };
  name: string;
  logo: string;
  description: string;
};

export type GlobalNotificationPreferences = {
  promotions: boolean;
  recommendations: boolean;
  volunteer: boolean;
  degrees: boolean;
  reminders: boolean;
};

export type CourseraNormalizedEmailPreference = {
  id: string;
  value:
    | { promotions: boolean }
    | { recommendations: boolean }
    | { volunteer: boolean }
    | { degrees: boolean }
    | { reminders: boolean };
  name: string;
};

export type CourseEmailType = keyof CourseEmailPreference['value'];

export const COURSE_EMAIL_TYPES: CourseEmailType[] = ['announcements', 'reminders', 'discussionForums'];

export type PartnerEmailPreference = {
  id: string;
  value: {
    subscriptions: boolean;
  };
  name: string;
  logo?: string;
};

export type EmailPreference = CourseraNormalizedEmailPreference | PartnerEmailPreference | CourseEmailPreference;

export type UpdateStatus = {
  state: (typeof UpdateStates)[keyof typeof UpdateStates];
};
